/* Invite Craftly — small progressive enhancements (no dependencies) */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function reveal() {
    var els = document.querySelectorAll('.ic-reveal:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }
  function filters() {
    document.querySelectorAll('[data-ic-filter]').forEach(function (bar) {
      var scope = document.getElementById(bar.getAttribute('data-ic-filter'));
      if (!scope) return;
      bar.addEventListener('click', function (ev) {
        var btn = ev.target.closest('button[data-value]');
        if (!btn) return;
        bar.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        var v = btn.getAttribute('data-value');
        scope.querySelectorAll('[data-tags]').forEach(function (card) {
          card.hidden = v !== 'all' && (' ' + card.getAttribute('data-tags') + ' ').indexOf(' ' + v + ' ') === -1;
        });
      });
    });
  }
  function honeypot() {
    document.querySelectorAll('form[data-ic-hp]').forEach(function (f) {
      var started = Date.now();
      f.addEventListener('submit', function (ev) {
        var hp = f.querySelector('.ic-hp input');
        if ((hp && hp.value) || Date.now() - started < 2500) { ev.preventDefault(); }
      });
    });
  }
  function init() { reveal(); filters(); honeypot(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', reveal);
})();
